
<template>
    <svg :style="iconFill" v-if="size == 0" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 38.502 16.171">
        <defs>
            <linearGradient id="linear-gradient" x1="1" y1="1.887" x2="-0.044" y2="-0.753" gradientUnits="objectBoundingBox">
                <stop offset="0" :stop-color="$highlightedLicenseGradient2"/><stop offset="1" :stop-color="$highlightedLicenseGradient1"/>
            </linearGradient>
        </defs>
        <path id="Path_583" data-name="Path 583" class="cls-1" d="M42.651,16.171,61.9,11.551V5.39L42.651,0,23.4,5.39v6.16Z" transform="translate(-23.4)"/>
    </svg>

    <svg :style="iconFill" v-else-if="size == 1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 38.502 21.561">
        <defs>
            <linearGradient id="linear-gradient" x1="1" y1="1.887" x2="-0.044" y2="-0.753" gradientUnits="objectBoundingBox">
                <stop offset="0" :stop-color="$highlightedLicenseGradient2"/><stop offset="1" :stop-color="$highlightedLicenseGradient1"/>
            </linearGradient>
        </defs>
        <path id="Path_580" data-name="Path 580" class="cls-1" d="M42.651,16.171,61.9,11.551V5.39L42.651,0,23.4,5.39v6.16Z" transform="translate(-23.4)"/>
        <path id="Path_581" data-name="Path 581" class="cls-1" d="M23.4,1.7V4.78l19.251,5.39L61.9,4.78V1.7L42.651,7.09Z" transform="translate(-23.4 11.391)"/>
    </svg>

    <svg :style="iconFill" v-else-if="size == 2" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 38.502 26.181">
        <defs>
            <linearGradient id="linear-gradient" x1="1" y1="1.887" x2="-0.044" y2="-0.753" gradientUnits="objectBoundingBox">
                <stop offset="0" :stop-color="$highlightedLicenseGradient2"/><stop offset="1" :stop-color="$highlightedLicenseGradient1"/>
            </linearGradient>
        </defs>
        <path id="Path_577" data-name="Path 577" class="cls-1" d="M42.651,16.171,61.9,11.551V5.39L42.651,0,23.4,5.39v6.16Z" transform="translate(-23.4)"/>
        <path id="Path_578" data-name="Path 578" class="cls-1" d="M23.4,1.7V4.78l19.251,5.39L61.9,4.78V1.7L42.651,7.09Z" transform="translate(-23.4 11.391)"/>
        <path id="Path_579" data-name="Path 579" class="cls-1" d="M23.4,2.4V4.71L42.651,10.1,61.9,4.71V2.4L42.651,7.02Z" transform="translate(-23.4 16.081)"/>
    </svg>

    <svg :style="iconFill" v-else-if="size == 3" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 38.502 31.572">
        <defs>
            <linearGradient id="linear-gradient" x1="1" y1="1.887" x2="-0.044" y2="-0.753" gradientUnits="objectBoundingBox">
                <stop offset="0" :stop-color="$highlightedLicenseGradient2"/><stop offset="1" :stop-color="$highlightedLicenseGradient1"/>
            </linearGradient>
        </defs>
        <path id="Path_573" data-name="Path 573" class="cls-1" d="M42.651,16.171,61.9,11.551V5.39L42.651,0,23.4,5.39v6.16Z" transform="translate(-23.4 0)"/>
        <path id="Path_574" data-name="Path 574" class="cls-1" d="M23.4,1.7V4.78l19.251,5.39L61.9,4.78V1.7L42.651,7.09Z" transform="translate(-23.4 11.391)"/>
        <path id="Path_575" data-name="Path 575" class="cls-1" d="M23.4,2.4V4.71L42.651,10.1,61.9,4.71V2.4L42.651,7.02Z" transform="translate(-23.4 16.081)"/>
        <path id="Path_576" data-name="Path 576" class="cls-1" d="M23.4,3V6.08l19.251,5.39L61.9,6.08V3L42.651,8.39Z" transform="translate(-23.4 20.101)"/>
    </svg>

    <svg :style="iconFill" v-else-if="size == 4" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 38.502 36.962">
        <defs>
            <linearGradient id="linear-gradient" x1="1" y1="1.887" x2="-0.044" y2="-0.753" gradientUnits="objectBoundingBox">
                <stop offset="0" :stop-color="$highlightedLicenseGradient2"/><stop offset="1" :stop-color="$highlightedLicenseGradient1"/>
            </linearGradient>
        </defs>
        <path :style="iconFill" id="Path_558" data-name="Path 558" class="cls-1" d="M42.651,16.171,61.9,11.551V5.39L42.651,0,23.4,5.39v6.16Z" transform="translate(-23.4)"/>
        <path id="Path_559" data-name="Path 559" class="cls-1" d="M23.4,1.7V4.78l19.251,5.39L61.9,4.78V1.7L42.651,7.09Z" transform="translate(-23.4 11.391)"/>
        <path id="Path_560" data-name="Path 560" class="cls-1" d="M23.4,2.4V4.71L42.651,10.1,61.9,4.71V2.4L42.651,7.02Z" transform="translate(-23.4 16.081)"/>
        <path id="Path_561" data-name="Path 561" class="cls-1" d="M23.4,3V6.08l19.251,5.39L61.9,6.08V3L42.651,8.39Z" transform="translate(-23.4 20.101)"/>
        <path id="Path_562" data-name="Path 562" class="cls-1" d="M23.4,3.7V6.78l19.251,5.39L61.9,6.78V3.7L42.651,9.09Z" transform="translate(-23.4 24.792)"/>
    </svg>
</template>

<script>
    import Configure from './../../mixins/configure'

    export default {
        props: {
            size: [Number,String],
            highlightedLicense: {
                type: Boolean,
                default: false
            },
        },
        mixins: [Configure],
        computed: {
            iconFill() {
                let fill = (this.highlightedLicense) ? this.$highlightedLicenseTextColor : 'url(#linear-gradient)'
                return {
                    fill
                }
            }
        }
    }
</script>